import { render, staticRenderFns } from "./AccountQuick.vue?vue&type=template&id=8eb885ca&scoped=true&"
import script from "./AccountQuick.vue?vue&type=script&lang=js&"
export * from "./AccountQuick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb885ca",
  null
  
)

export default component.exports